import {SvgIcon} from "@material-ui/core";

export const CustomApplicationListIcon = (props) => {
    return (
        <SvgIcon width="20" height="21" viewBox="0 0 20 21" fill="#CDBDDB" {...props}>
            <path d="M15.8333 4.70768V16.3743H4.16667V4.70768H15.8333ZM16.75 3.04102H3.25C2.83333 3.04102 2.5 3.37435 2.5 3.79102V17.291C2.5 17.6243 2.83333 18.041 3.25 18.041H16.75C17.0833 18.041 17.5 17.6243 17.5 17.291V3.79102C17.5 3.37435 17.0833 3.04102 16.75 3.04102ZM9.16667 6.37435H14.1667V8.04102H9.16667V6.37435ZM9.16667 9.70768H14.1667V11.3743H9.16667V9.70768ZM9.16667 13.041H14.1667V14.7077H9.16667V13.041ZM5.83333 6.37435H7.5V8.04102H5.83333V6.37435ZM5.83333 9.70768H7.5V11.3743H5.83333V9.70768ZM5.83333 13.041H7.5V14.7077H5.83333V13.041Z"/>
        </SvgIcon>
    )
}